import { useIsAuthenticated } from '@azure/msal-react';

import { useAppDispatch } from '../../../../store/hooks';
import { setActiveMandant } from '../../../mandant/slices/mandant.slice';
import { getMandants } from '../../../mandant/thunks/get-mandants.thunk';
import { LocalStorageProperties } from '../../enums/local-storage-properties.enum';
import localStorageService from '../../services/local-storage/local-storage.service';
import { castTo } from '../../utils/cast-to';

export const useGetAssignedMandantHook = (): (() => Promise<void>) => {
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useAppDispatch();

  return async () => {
    if (isAuthenticated) {
      try {
        const data = await dispatch(getMandants()).unwrap();
        const selectedMandant = localStorageService.get(
          LocalStorageProperties.SELECTED_MANDANT
        );
        if (!selectedMandant && data && data.length) {
          localStorageService.set(
            LocalStorageProperties.SELECTED_MANDANT,
            data[0].id
          );
          dispatch(setActiveMandant(data[0].id));
          return;
        }

        dispatch(
          setActiveMandant(parseInt(castTo<string>(selectedMandant), 10))
        );
      } catch (err: unknown) {
        console.warn('Something went wrong while getting the mandants!');
      }
    }
  };
};
